<div mat-dialog-content>
  <div class="text-center">
    <div class="i-circle danger">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <h4 class="color-default">{{'WORKFLOW_CHANGE_CONFIRMATION'|translate}}</h4>
  </div>

  <form [formGroup]="form" class="form-horizontal" *ngIf="form">
    <div class="col-sm-12 margin-top-10">
      <div class="panel panel-default">
        <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopupPopup1"
          (click)="collPnPopupPopup1 = !collPnPopupPopup1">
          <h5 class="panel-title">
            <i class="fas fa-file-alt"></i>
            <strong>{{'ADDRESSES_FOR_SENDING_EMAIL'|translate}}</strong>
            <i class="collapse-icon fas"
              [ngClass]="{'fa-caret-down': collPnPopupPopup1, 'fa-caret-up': !collPnPopupPopup1}"></i>
          </h5>
        </div>
        <div id="collPnPopupPopup1" class="panel-body no-horizontal-padding collapse in">
          <div class="form-group">
            <div class="col-sm-12 margin-bottom-30" formArrayName="emails">
              <div class="form-group">
                <div class="col-sm-12">
                  <button type="button" class="btn btn-sm btn-primary" title="{{'ADD_EMAIL' | translate}}"
                    (click)="addEmail()">
                    <i class="fas fa-plus"></i>&nbsp;{{'ADD_EMAIL' | translate}}
                  </button>
                </div>
              </div>

              <div class="form-group" *ngFor="let item of form.controls.emails.controls; let i=index"
                [formGroupName]="i">
                <div class="col-sm-12">
                  <mat-form-field class="full-width">
                    <mat-label>{{'EMAIL'|translate}}</mat-label>
                    <input type="email" matInput formControlName="email">
                    <button type="button" matSuffix class="no-btn">
                      <i class="far fa-trash-alt color-danger" (click)="deleteEmail(i)"></i>
                    </button>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <div class="full-width text-right">
    <button type="button" class="btn btn-danger" title="{{'NO' | translate}}" (click)="dialogRef.close(null)">
      <i class="fas fa-times"></i>&nbsp;{{'NO' | translate}}
    </button>
    <button type="button" class="btn btn-success" title="{{'YES' | translate}}" (click)="save()"
      [disabled]="form.invalid">
      <i class="fas fa-check"></i>&nbsp;{{'YES' | translate}}
    </button>
  </div>
</div>